import { useEffect, useState } from 'react';
import copy from 'clipboard-copy';
import { FlatButton } from '@signavio/ui';
import { TextInput } from '@signavio/ui/future';
import i18n from '@signavio/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
function CopyToClipboard({
  children,
  description,
  label,
  labelPosition = 'left',
  readOnly = false
}) {
  const [isCopied, setIsCopied] = useState(false);
  useEffect(() => {
    if (!isCopied) {
      return;
    }
    void copy(children);
    const timeout = window.setTimeout(() => setIsCopied(false), 3 * 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [isCopied, children]);
  return /*#__PURE__*/_jsx(TextInput, {
    clearable: false,
    labelPosition: labelPosition,
    controls: /*#__PURE__*/_jsx(FlatButton, {
      icon: "clipboard-copy",
      "aria-pressed": isCopied,
      "data-testid": "copy-text-button",
      onClick: () => {
        setIsCopied(true);
      },
      children: isCopied ? i18n('Copied!') : i18n('Copy')
    }),
    description: description,
    label: label,
    onFocus: () => {
      setIsCopied(true);
    },
    value: children,
    readOnly: readOnly
  });
}
export default CopyToClipboard;